import source from 'src/client/markdown-content/markdown-pages/AdvancedGuidesContent.md';
import { MarkdownContent } from '../MarkdownContent';

export const AdvancedGuideTopics = (): JSX.Element => <MarkdownContent source={source} pageRoute="advancedTopics" />;
